"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerType = exports.PROVIDER_TYPES = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var PROVIDER_TYPES = Object.freeze({
  OTHER: 'Other',
  BANK_STATEMENT: 'BankStatement',
  PAYSTUB: 'Paystub',
  TAX_RETURN: 'TaxReturn',
  W2: 'W2'
});
exports.PROVIDER_TYPES = PROVIDER_TYPES;

var providerType = _propTypes.default.shape({
  providerId: _propTypes.default.string,
  providerName: _propTypes.default.string,
  providerType: _propTypes.default.symbol
});

exports.providerType = providerType;